import { createAction, createAsyncThunk } from '@reduxjs/toolkit'
import { toastError } from '@src/helpers/toastError'
import { PayloadCreatorParams } from '@src/redux/types'
import { omit } from 'ramda'

import * as api from '../api'
import {
  LOGS_ASSESSMENT_AUDIT,
  LOGS_ASSESSMENT_STUDENT_LIST,
  LOGS_ASSESSMENT_STUDENT_SUBMISSIONS,
} from '../constants/actionTypes'
import * as API from '../constants/api'

export const logsAssessmentAudit = createAsyncThunk(
  LOGS_ASSESSMENT_AUDIT,
  async (params: PayloadCreatorParams<`${typeof API.LOGS_ASSESSMENT_AUDIT}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.logsAssessmentAudit(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const logsAssessmentStudentList = createAsyncThunk(
  LOGS_ASSESSMENT_STUDENT_LIST,
  async (params: PayloadCreatorParams<`${typeof API.LOGS_ASSESSMENT_STUDENT_LIST}`, 'get'>, { rejectWithValue }) => {
    try {
      const response = await api.logsAssessmentStudentList(omit(['onFulfilled', 'onRejected', 'onSettled'], params))
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const logsAssessmentStudentSubmissions = createAsyncThunk(
  LOGS_ASSESSMENT_STUDENT_SUBMISSIONS,
  async (
    params: PayloadCreatorParams<`${typeof API.LOGS_ASSESSMENT_STUDENT_SUBMISSIONS}`, 'get'>,
    { rejectWithValue }
  ) => {
    try {
      const response = await api.logsAssessmentStudentSubmissions(
        omit(['onFulfilled', 'onRejected', 'onSettled'], params)
      )
      params?.onFulfilled && params.onFulfilled(response.data)
      return response.data
    } catch (e) {
      const error = toastError(e)
      params?.onRejected && params.onRejected({ error })
      return rejectWithValue(error)
    } finally {
      params?.onSettled && params.onSettled()
    }
  }
)

export const logsAssessmentStudentListClear = createAction(`${LOGS_ASSESSMENT_STUDENT_LIST}/clear`)
